import React from 'react'
import { useSelector } from 'react-redux'
import {
  REACT_APP_OPENED_DATA_URL,
  REACT_APP_BASE_URL,
  REACT_APP_FEATURE_FLAG_DOWNLOAD_BUTTON,
  REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION
} from '../../config/settings/environment'
import {
  InfoOpenDataButton,
  Column,
  DownloadPDFButton,
  ColumnOpenData,
  DownloadIcon,
  LaunchOpenDataIcon
} from './OpenDataInformationButton.styles'

/**
 * The Open Data Information Button' container.
 */
const OpenDataInformationButton = () => {
  const { error: buyerError } = useSelector(state => state.basicBuyerInformation)
  const { dni, entCode } = useSelector(state => state.basicBuyerInformation)

  return buyerError ? null : (
    <ColumnOpenData>
      {(REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION === true ||
        REACT_APP_FEATURE_FLAG_LINK_TO_OPEN_DATA_INFORMATION_SECTION === 'true') && (
        <Column padding="0">
          <InfoOpenDataButton
            color="primary"
            target="_blank"
            to={`${REACT_APP_OPENED_DATA_URL}ficha-organismo/${entCode}`}
            variant="outlined"
            tabIndex="0"
            aria-label="Abre datos abiertos en otra ventana"
          >
            <LaunchOpenDataIcon alt="Informacion Datos Abiertos" />
            Ver información de compras en Datos Abiertos
          </InfoOpenDataButton>
        </Column>
      )}
      {(REACT_APP_FEATURE_FLAG_DOWNLOAD_BUTTON === true || REACT_APP_FEATURE_FLAG_DOWNLOAD_BUTTON === 'true') && (
        <Column padding="0">
          <DownloadPDFButton
            target="_blank"
            to={`${REACT_APP_BASE_URL}/ficha/descargar/${dni}`}
            variant="outlined"
            tabIndex="0"
            aria-label="Descarga ficha comprador en PDF"
          >
            <DownloadIcon alt="Descargar ficha en PDF" />
            Descargar ficha en formato PDF
          </DownloadPDFButton>
        </Column>
      )}
    </ColumnOpenData>
  )
}

export default OpenDataInformationButton
